import Boss from "./Boss";
import {MiniSignal, spine} from "p3";
import definitions from "../../definitions";
import { locale } from "../../utils";

export default class BossQueenMoleworm extends Boss {
    constructor() {
        super(definitions.BOSS_ID.QUEEN_MOLEWORM);

        this._isAttacking = false;
        this._isAttackReady = false;
        this._isTakingDamage = false;
        this._skinNormal = null;

        // override some default stats for this boss
        this.minDamage = 2;
        this.maxDamage = 5; 
        this.health = 32;
        this.iconTextureId = "icon_char_queen_moleworm";
        this.name = locale("npc_queen_moleworm_name");
    }

    init() {
        super.init();

        //this.signals.hit.add(() => P3.audio.playSound(["sfx_boss_batwitch_attack_00","sfx_boss_batwitch_attack_01","sfx_boss_batwitch_attack_02"]), this);

        this.addViewWithSpine(spine("boss_queenworm"));

        this._view.stateData.defaultMix = 0.1;
        this._view.scale.set(0.5);
        this._view.x -= 100;
        this._view.y -= 400;

        this.playIdleAnimation();

        P3.audio.playSound("sfx_boss_worm_queen_ready_00");

        this.signals.attackEnd = new MiniSignal();
        this.signals.dead.add(() => {
            this._isAttacking = false;
            this._isTakingDamage = false;
            this.playAnimation("defeat_00", true);
            P3.audio.playSound("sfx_boss_worm_queen_die_00");
        }, this);
    }

    destroy() {
        super.destroy();
    }

    onViewAdded() {
        super.onViewAdded();
    }

    update() {
        super.update();

        this._view && this._view.update(window.dt);
    }

    /**
     * @param {number} state
     * @private
     */
    onStateEnter(state) {
        switch (state) {
            case definitions.BOSS_STATE.IDLE: {
                break;
            }
            case definitions.BOSS_STATE.TAKE_DAMAGE: {
                if(!this.isTakingDamage && !this.isAttacking) {
                    this._startTakeDamage();
                }
                break;
            }
            case definitions.BOSS_STATE.ATTACK: {
                break;
            }
            case definitions.BOSS_STATE.DEAD: {
                this.playAnimation("defeat_00", true);
                break;
            }
        }
    }

    /**
     * @param {number} state
     * @private
     */
    onStateUpdate(state) {
        switch (state) {
            case definitions.BOSS_STATE.IDLE: {
                break;
            }
            case definitions.BOSS_STATE.TAKE_DAMAGE: {
                break;
            }
            case definitions.BOSS_STATE.ATTACK: {
                if(!this.isTakingDamage && !this.isAttacking) {
                    this._startAttack();
                }
                break;
            }
            case definitions.BOSS_STATE.DEAD: {
                break;
            }
        }
        this._attackTime += window.dt;
    }

    /**
     * @param {number} state
     * @private
     */
    onStateExit(state) {
        switch (state) {
            case definitions.BOSS_STATE.ATTACK: {
                this._isAttacking = false;
                break;
            }
            case definitions.BOSS_STATE.TAKE_DAMAGE: {
                this._isTakingDamage = false;
                break;
            }
        }
    }

    playIdleAnimation() {
        this.playAnimation("idle_00", true);
    }

    _startAttack() {
        if (!this._isAttacking) {
            this._attackTime = 0;
            this._isAttacking = true;
            this.playAnimation("attack_00");

            P3.audio.playSound([
                "sfx_boss_worm_queen_attack_00",
                "sfx_boss_worm_queen_attack_01"
            ]);
        }
    }

    _startTakeDamage() {
        this._isTakingDamage = true;
        P3.audio.playSound([
            "sfx_boss_worm_queen_take_damage_00",
            "sfx_boss_worm_queen_take_damage_01"
        ]);
        this.playAnimation("take_hit_00");
    }

    onAnimationComplete(name, entry) {
        if(name === "attack_00") {
            this.playIdleAnimation();
            this.signals.attackEnd.dispatch();
        }
    }
    
    onAnimationEvent(entry, event) {
        if (event.stringValue === "sfx_attack") {
            this.signals.bossStrike.dispatch();
        }
    }

    get isAttacking() {
        return this._isAttacking;
    }

    get isTakingDamage() {
        return this._isTakingDamage;
    }
}